import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
const DEFAULT_SECTION_STATE = {
    collapsed: false,
    hiddenWhileDone: false
};
const isStoredSectionState = (value)=>typeof value === 'object' && value !== null && typeof value.collapsed === 'boolean' && typeof value.hiddenWhileDone === 'boolean';
const readSectionState = (storage, key)=>{
    try {
        const raw = storage.getItem(key);
        const parsed = raw == null ? null : JSON.parse(raw);
        return isStoredSectionState(parsed) ? parsed : DEFAULT_SECTION_STATE;
    } catch (unused) {
        return DEFAULT_SECTION_STATE;
    }
};
const writeSectionState = (storage, key, state)=>{
    try {
        storage.setItem(key, JSON.stringify(state));
    } catch (unused) {
        return;
    }
};
export const makeSectionStorage = (storage, userId, businessId)=>{
    const key = "pulse-revenue-opportunities:".concat(userId, ":").concat(businessId);
    const update = (change)=>writeSectionState(storage, key, _object_spread({}, readSectionState(storage, key), change));
    return {
        isCollapsed: ()=>readSectionState(storage, key).collapsed,
        setCollapsed: (collapsed)=>update({
                collapsed
            }),
        isHiddenWhileDone: ()=>readSectionState(storage, key).hiddenWhileDone,
        hideWhileDone: ()=>update({
                hiddenWhileDone: true
            }),
        releaseHide: ()=>update({
                hiddenWhileDone: false
            })
    };
};
